import { ArrowRight, ShieldCheck, Phone } from "lucide-react";
import { company, heroStats } from "../mock";
import { Button } from "./ui/button";

const HERO_IMG =
  "https://images.unsplash.com/photo-1720351320133-a9bb8fd0b500?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxwb3dlciUyMGdyaWR8ZW58MHx8fGJsdWV8MTc4OTU1MTU2OHww&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section
      id="etusivu"
      className="relative min-h-[100svh] flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Sähköverkon infrastruktuuri"
          className="w-full h-full object-cover"
        />
        {/* Blue overlays for contrast */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#08234f]/95 via-[#0b2c63]/85 to-[#0b2c63]/45" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#08234f]/80 via-transparent to-[#08234f]/30" />
        <div className="absolute inset-0 circuit-bg opacity-[0.18]" />
      </div>

      {/* Content */}
      <div className="relative w-full max-w-7xl mx-auto px-5 lg:px-8 pt-28 pb-20 lg:py-32">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 backdrop-blur-sm text-white ring-1 ring-white/25 px-4 py-1.5 text-sm font-semibold mb-6">
            <ShieldCheck className="w-4 h-4 text-sky-300" />
            {company.anniversary}
          </div>

          <h1 className="font-extrabold text-white leading-[1.05] text-4xl sm:text-5xl lg:text-6xl tracking-tight">
            Sähköisen tilan{" "}
            <span className="relative whitespace-nowrap">
              <span className="relative z-10 text-sky-300">ylläpito</span>
              <span className="absolute bottom-1 left-0 w-full h-3 bg-sky-400/25 -z-0" />
            </span>
          </h1>

          <p className="mt-6 text-lg text-slate-200 max-w-xl leading-relaxed">
            Selekto toteuttaa ja kehittää sähköpalveluja asiakkaan eduksi –
            lämpökuvauksesta ja mittauksista aina käytönjohtajapalveluihin.
            Toimialueena {company.region}.
          </p>

          <div className="mt-8 flex flex-wrap gap-4">
            <Button
              asChild
              size="lg"
              className="rounded-full px-7 h-12 text-base gap-2 shadow-xl shadow-black/30"
            >
              <a href="#palvelut">
                Tutustu palveluihin
                <ArrowRight className="w-4 h-4" />
              </a>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="rounded-full px-7 h-12 text-base gap-2 bg-white/5 backdrop-blur-sm border-white/40 text-white hover:bg-white hover:text-primary"
            >
              <a href={`tel:${company.phoneRaw}`}>
                <Phone className="w-4 h-4" />
                Soita meille
              </a>
            </Button>
          </div>

          {/* Stats */}
          <div className="mt-12 grid grid-cols-2 gap-4 max-w-sm">
            {heroStats.map((s) => (
              <div key={s.label} className="border-l-2 border-sky-400/50 pl-4">
                <div className="font-[Sora] font-extrabold text-2xl lg:text-3xl text-white">
                  {s.value}
                </div>
                <div className="text-xs lg:text-sm text-slate-300 mt-1">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Floating badge */}
      <div className="absolute bottom-40 right-5 lg:right-10 glass-card rounded-2xl p-4 shadow-2xl max-w-[230px] hidden sm:block">
        <div className="flex items-center gap-3">
          <span className="grid place-items-center w-11 h-11 rounded-xl bg-primary text-white shrink-0">
            <ShieldCheck className="w-5 h-5" />
          </span>
          <div>
            <div className="font-semibold text-slate-900 text-sm">SETI LK1</div>
            <div className="text-xs text-slate-500">Sertifioitu lämpökuvaaja</div>
          </div>
        </div>
      </div>
    </section>
  );
}
